import React from "react";
import { Card } from "react-bootstrap";
import { Outlet } from "react-router-dom";

export default function OrderLayout() {
  return (
    <div>
        <Outlet />
    </div>
  )
}
